import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { isDesktop, useDemoAnalytics } from '@carboncopyco/utils';
import { useParams } from 'react-router-dom';
import { NotesInDesktopMessage, SpeakerNotesCard } from '../../../SpeakerNotes';
import { usePermissionsContext } from '../../../utils';
import { useDemoPageProps } from '../DemoPageContext';
import { DemoPageTabLayout } from '../DemoPageTabLayout';

export const SpeakerNotesTab = () => {
  const {
    showNotesInDesktopMessage,
    onCloseNotesInDesktopMessage,
    noteValue,
    setNoteValue,
    readOnly,
  } = useDemoPageProps();
  const { demoId } = useParams();
  const { getPermissions } = usePermissionsContext();

  const userHasNoteEditingPermission = getPermissions(
    PermissionKey.note,
    PermissionAction.updateNoteById
  );

  const { trackDemoAddSpeakerNotes } = useDemoAnalytics(
    'demo_page_speaker_notes_tab'
  );

  return (
    <DemoPageTabLayout>
      <div className="h-full flex flex-col pb-10">
        {!isDesktop() && showNotesInDesktopMessage && (
          <NotesInDesktopMessage onClose={onCloseNotesInDesktopMessage} />
        )}
        <div className="grow">
          <SpeakerNotesCard
            isEditable={!readOnly && userHasNoteEditingPermission}
            entityId={demoId}
            entityType="demo"
            value={noteValue}
            setValue={setNoteValue}
            onAddNote={() => {
              trackDemoAddSpeakerNotes({ demoId });
            }}
          />
        </div>
      </div>
    </DemoPageTabLayout>
  );
};
